import { FeatureFlags, FeatureFlagsObject, FeatureFlagVariant } from './types';

/* DISCLAIMER: Do not export or use this function directly  */
export const getFlags = (): FeatureFlags => {
  const flags = (global?._INITIAL_DATA_?.featureFlags as FeatureFlagsObject)
    ?.flags;
  return flags ?? {};
};

export const getUser = () => {
  const user = (global?._INITIAL_DATA_?.featureFlags as FeatureFlagsObject)
    ?.user;
  return user;
};

export const createFeatureFlagObject = (
  value: FeatureFlagVariant | undefined,
  isExperiment: boolean | undefined
) => ({
  value: value ?? false,
  isExperiment: isExperiment ?? false
});
